import { GridSortModel } from "@mui/x-data-grid";
import { Dayjs } from "dayjs";
import { DealerAccount } from "../../../api/dealer/types";
import { OrderLine } from "../../../api/orders/orderInterfaces";

export type OrdersByLineItemState = {
  accountId: string;
  orderLines: OrderLine[];
  isLoading: boolean;
  isDownloading: boolean;
  isDownloadFailed: boolean;
  isTechnicalError: boolean;
  isAuthorizedError: boolean;
  isAuthenticationError: boolean;
  filters: OrdersByLineItemFilter;
  isFilterApplied: boolean;
  featureToggles: FeatureToggles;
  selectedAccounts: DealerAccount[];
  currentPage: number;
  pageRowSize: number;
  totalOrderLines: number;
  sortModel: GridSortModel;
  orderStatusCounts: LineStatusCount[];
  orderLinesStatusCountLoading: Record<number, boolean>;
  tabIndex: number;
  zeroTabLineStatusFilter?: LineStatus[];
  downloadStates: DownloadStates;
};

export type LineStatusCount = {
  totalLinesCount: number;
  lineStatuses: LineStatus[];
};

export type OrderLineRowSortField = keyof Omit<
  OrderLine,
  | "orderStatus"
  | "placeInLine"
  | "serviceLevelAgreementCode"
  | "serviceLevelAgreementDescription"
>;
export const TAB_NAMES = [
  "AllLines",
  "Backorders",
  "OnHold",
  "Investigations",
  "SentToSupplier",
  "SentToFactory",
];
export type DownloadStates = Record<
  (typeof TAB_NAMES)[number],
  TabDownloadState
>;

export type OrdersByLineItemFilter = {
  partNumber?: string;
  dealerReference?: string;
  promotionId?: string;
  lineStatus?: LineStatus[];
  latestOrderCreationDateTo?: Dayjs;
  latestOrderCreationDateFrom?: Dayjs;
};

export type FeatureToggles = {
  isInvestigationMessagesEnabled: boolean;
  isRBACEnabled: boolean;
  isCorporateViewEnabled: boolean;
  isOrdersEnabled: boolean;
  isPromotionsEnabled: boolean;
  SLAColumnEnabled: boolean;
  isDateTimeCreated: boolean;
};

export enum OrderStatus {
  UNSUBMITTED = "UNSUBMITTED",
  SUBMITTED = "SUBMITTED",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  ON_HOLD = "ON_HOLD",
  IN_PROCESS = "IN_PROCESS",
}

export enum LineStatus {
  CONFIRMED = "CONFIRMED",
  BACK_ORDERED = "BACK_ORDERED",
  SENT_TO_SUPPLIER = "SENT_TO_SUPPLIER",
  DEERE_INVESTIGATION = "DEERE_INVESTIGATION",
  IN_PROCESS = "IN_PROCESS",
  DEALER_INVESTIGATION = "DEALER_INVESTIGATION",
  USER_CANCELLED = "USER_CANCELLED",
  AUTO_CANCELLED = "AUTO_CANCELLED",
  SHIPPED = "SHIPPED",
  ON_HOLD = "ON_HOLD",
  PARTIALLY_SHIPPED = "PARTIALLY_SHIPPED",
  CANCELLED = "CANCELLED",
  ORDERED = "ORDERED",
  SENT_TO_FACTORY = "SENT_TO_FACTORY",
  ROUTED = "ROUTED",
  EXPORT_RESHIP = "EXPORT_RESHIP",
  ROUTED_TO_DEALER = "ROUTED_TO_DEALER",
  SENT_TO_DEALER = "SENT_TO_DEALER",
  SHIPPED_BY_DEALER = "SHIPPED_BY_DEALER",
}

export type UpdateSelectedAccountsPayload = {
  selectedAccounts: DealerAccount[];
};

export type OrderLineRow = {
  orderNumber: string;
  orderStatus: string;
  promotionId?: string;
  investigation?: string;
  lineStatusCodes?: string[];
  dealerReference?: string;
  orderType: string;
  lineStatus: string;
  partNumber: string;
  promiseDate?: string;
  backOrderedDate?: string;
  id: string;
  shipDate?: string;
  submittedAt?: string;
  shippingUnit?: string;
  serviceLevelAgreement?: string;
  accountId?: string;
};

export type FiltersProps = {
  ordersByLineItemFilters: OrdersByLineItemFilter;
  isFilterApplied: boolean;
  onClearFilters: () => void;
  onFilterChange?: (filters: OrdersByLineItemFilter) => void;
};
export type TabDownloadState = {
  isDownloading: boolean;
  isDownloadFailed: boolean;
};
